const describeVacantInventorySpace = (inventory, { bag_index } = {}) => {
  let is_room = false;
  let bag_with_room;
  let index_with_room;

  if (bag_index) {
    for (let k = 0; k < inventory.bags[bag_index].items.length; ++k) {
      if (inventory.bags[bag_index].items[k]?.value == null) {
        is_room = true;
        bag_with_room = bag_index;
        index_with_room = k;
        break;
      }
    }
  } else {
    for (let i = 0; i < inventory.bags.length; ++i) {
      if (is_room) {
        break;
      }
      const bag = inventory.bags[i];
      if (!bag) {
        continue;
      }
      for (let j = 0; j < bag.items.length; ++j) {
        if (bag.items[j]?.value == null) {
          is_room = true;
          bag_with_room = i;
          index_with_room = j;
          break;
        }
      }
      if (is_room) {
        break;
      }
    }
  }

  return {
    is_room,
    bag_with_room,
    index_with_room,
  };
};
module.exports = describeVacantInventorySpace;
